import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserRolesService } from 'src/app/services/user-roles.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-userroles',
  templateUrl: './userroles.component.html',
  styleUrls: ['./userroles.component.scss']
})
export class UserrolesComponent implements OnInit {
  public loadedRoles:boolean=false;
  public userRoles:any[];
  public paginatedUserRoles = new BehaviorSubject<any>(null);
  private perPage=20;

  constructor(
    private _userRoles: UserRolesService,
    private _route: Router
  ) { }

  public getUserRoles(page){
    this._userRoles.getPaginatedUserRoles(page, this.perPage).subscribe(paginatedData => {
      this.paginatedUserRoles.next(paginatedData);
      this.loadedRoles=true;
    });
  }

  public addNewUserRole(){
    if(!confirm('Confirm you want to add a new User Role.')) return false;
    this._userRoles.addNewUserRole('New User Role').subscribe(
      (res:any)=>{
        this._route.navigate(['/user-roles/'+res.id]);
      }
    );
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getUserRoles(data.pageIndex+1);
  }

  perPageChanged(data){
    this.perPage=data.pageSize;
    this.getUserRoles(1);
  }

  ngOnInit() {
    this.getUserRoles(1);
  }

}
